<template>
  <div class="home-container">
    <app-navbar8>
      <template v-slot:page4Description>
        <div class="home-fragment10">
          <span class="home-text10">Page Four Description</span>
        </div>
      </template>
      <template v-slot:action1>
        <div class="home-fragment11">
          <span class="home-text11">About us</span>
        </div>
      </template>
      <template v-slot:link2>
        <div class="home-fragment12">
          <span class="home-text12">Portfolio / Finished Works</span>
        </div>
      </template>
      <template v-slot:page1>
        <div class="home-fragment13"><span class="home-text13">Home</span></div>
      </template>
      <template v-slot:link1>
        <div class="home-fragment14"><span class="home-text14">home</span></div>
      </template>
      <template v-slot:page4>
        <div class="home-fragment15">
          <span class="home-text15">Design Ideas</span>
        </div>
      </template>
      <template v-slot:page2>
        <div class="home-fragment16">
          <span class="home-text16">Inspiration</span>
        </div>
      </template>
      <template v-slot:link4>
        <div class="home-fragment17">
          <span class="home-text17">Design Hub</span>
        </div>
      </template>
      <template v-slot:page1Description>
        <div class="home-fragment18">
          <span class="home-text18">Page One Description</span>
        </div>
      </template>
      <template v-slot:page2Description>
        <div class="home-fragment19">
          <span class="home-text19">Page Two Description</span>
        </div>
      </template>
      <template v-slot:link3>
        <div class="home-fragment20">
          <span class="home-text20">#furniture</span>
        </div>
      </template>
      <template v-slot:page3>
        <div class="home-fragment21">
          <span class="home-text21">Furniture</span>
        </div>
      </template>
      <template v-slot:page3Description>
        <div class="home-fragment22">
          <span class="home-text22">Page Three Description</span>
        </div>
      </template>
      <template v-slot:action2>
        <div class="home-fragment23">
          <span class="home-text23">Secondary Action</span>
        </div>
      </template>
    </app-navbar8>
    <app-hero17 rootClassName="hero17root-class-name">
      <template v-slot:action2>
        <div class="home-fragment24">
          <span class="home-text24">Existsing Works</span>
        </div>
      </template>
      <template v-slot:action1>
        <div class="home-fragment25">
          <span class="home-text25">Services</span>
        </div>
      </template>
      <template v-slot:heading1>
        <div class="home-fragment26">
          <span class="home-text26">Welcome to Your Dream Home</span>
        </div>
      </template>
      <template v-slot:content1>
        <div class="home-fragment27">
          <span class="home-text27">
            Discover endless possibilities to transform your living space into a
            sanctuary of style and comfort.
          </span>
        </div>
      </template>
    </app-hero17>
    <app-features24>
      <template v-slot:feature3Description>
        <div class="home-fragment28">
          <span class="home-text28">
            Explore a variety of furniture options to suit your style and space.
          </span>
        </div>
      </template>
      <template v-slot:feature3Title>
        <div class="home-fragment29">
          <span class="home-text29">Furniture Options</span>
        </div>
      </template>
      <template v-slot:feature2Description>
        <div class="home-fragment30">
          <span class="home-text30">
            Get inspired by our curated collection of design ideas for every room
            in your home.
          </span>
        </div>
      </template>
      <template v-slot:feature1Title>
        <div class="home-fragment31">
          <span class="home-text31">Home Decor Inspiration</span>
        </div>
      </template>
      <template v-slot:feature1Description>
        <div class="home-fragment32">
          <span class="home-text32">
            Discover the latest trends and tips for decorating your home.
          </span>
        </div>
      </template>
      <template v-slot:feature2Title>
        <div class="home-fragment33">
          <span class="home-text33">Design Ideas</span>
        </div>
      </template>
    </app-features24>
    <app-cta26>
      <template v-slot:heading1>
        <div class="home-fragment34">
          <span class="home-text34">
            Transform Your Home with Our Interior Design Services
          </span>
        </div>
      </template>
      <template v-slot:content1>
        <div class="home-fragment35">
          <span class="home-text35">
            Discover a world of possibilities for your living space with our
            expert interior designers. From concept to execution, we&apos;ll bring
            your vision to life.
          </span>
        </div>
      </template>
      <template v-slot:action1>
        <div class="home-fragment36">
          <span class="home-text36">Explore Our Services</span>
        </div>
      </template>
    </app-cta26>
    <app-features25>
      <template v-slot:feature3Description>
        <div class="home-fragment37">
          <span class="home-text37">
            Get creative with our design ideas to transform your living spaces
            into stylish havens.
          </span>
        </div>
      </template>
      <template v-slot:feature1Description>
        <div class="home-fragment38">
          <span class="home-text38">
            Discover the latest trends and styles to inspire your home decor
            projects.
          </span>
        </div>
      </template>
      <template v-slot:feature2Title>
        <div class="home-fragment39">
          <span class="home-text39">Furniture Options</span>
        </div>
      </template>
      <template v-slot:feature1Title>
        <div class="home-fragment40">
          <span class="home-text40">Home Decor Inspiration</span>
        </div>
      </template>
      <template v-slot:feature2Description>
        <div class="home-fragment41">
          <span class="home-text41">
            Explore a wide range of furniture options to suit your taste and space
            requirements.
          </span>
        </div>
      </template>
      <template v-slot:feature3Title>
        <div class="home-fragment42">
          <span class="home-text42">Design Ideas</span>
        </div>
      </template>
    </app-features25>
    <app-contact10>
      <template v-slot:content1>
        <div class="home-fragment43">
          <span class="home-text43">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            varius enim in ero.
          </span>
        </div>
      </template>
      <template v-slot:location1Description>
        <div class="home-fragment44">
          <span class="home-text44">
            Visit our showroom for a personalized design consultation.
          </span>
        </div>
      </template>
      <template v-slot:heading1>
        <div class="home-fragment45">
          <span class="home-text45">Contact Us</span>
        </div>
      </template>
      <template v-slot:location2Description>
        <div class="home-fragment46">
          <span class="home-text46">
            Email us for any inquiries or collaborations.
          </span>
        </div>
      </template>
      <template v-slot:location1>
        <div class="home-fragment47">
          <span class="home-text47">123 Design Street, Cityville, ABC</span>
        </div>
      </template>
      <template v-slot:location2>
        <div class="home-fragment48">
          <span class="home-text48">contact@interiordesign.com</span>
        </div>
      </template>
    </app-contact10>
    <app-footer4>
      <template v-slot:link5>
        <div class="home-fragment49">
          <span class="home-text49">Privacy Policy</span>
        </div>
      </template>
      <template v-slot:link3>
        <div class="home-fragment50"><span class="home-text50">FAQs</span></div>
      </template>
      <template v-slot:link1>
        <div class="home-fragment51">
          <span class="home-text51">About Us</span>
        </div>
      </template>
      <template v-slot:termsLink>
        <div class="home-fragment52">
          <span class="home-text52">Terms and Conditions</span>
        </div>
      </template>
      <template v-slot:link2>
        <div class="home-fragment53">
          <span class="home-text53">Contact Us</span>
        </div>
      </template>
      <template v-slot:link4>
        <div class="home-fragment54">
          <span class="home-text54">Terms and Conditions</span>
        </div>
      </template>
      <template v-slot:cookiesLink>
        <div class="home-fragment55">
          <span class="home-text55">Cookies Policy</span>
        </div>
      </template>
      <template v-slot:privacyLink>
        <div class="home-fragment56">
          <span class="home-text56">Privacy Policy</span>
        </div>
      </template>
    </app-footer4>
    <app-banner1>
      <template v-slot:content1>
        <div class="home-fragment57">
          <span class="home-text57">
            Discover the latest trends and design ideas to create a space that
            reflects your personality and lifestyle.
          </span>
        </div>
      </template>
      <template v-slot:action1>
        <div class="home-fragment58">
          <span class="home-text58">Explore Design Ideas</span>
        </div>
      </template>
      <template v-slot:heading1>
        <div class="home-fragment59">
          <span class="home-text59">Transform Your Home with Style</span>
        </div>
      </template>
    </app-banner1>
    <contact-form7>
      <template v-slot:content1>
        <div class="home-fragment60">
          <span class="home-text60">Have a question or need assistance?</span>
        </div>
      </template>
      <template v-slot:email>
        <div class="home-fragment61"><span class="home-text61">Email</span></div>
      </template>
      <template v-slot:phone>
        <div class="home-fragment62"><span class="home-text62">Phone</span></div>
      </template>
      <template v-slot:action>
        <div class="home-fragment63">
          <span class="home-text63">Contact Us</span>
        </div>
      </template>
      <template v-slot:content2>
        <div class="home-fragment64">
          <span class="home-text64">
            Our team is here to help with any inquiries you may have. Feel free to
            reach out to us via email or phone.
          </span>
        </div>
      </template>
      <template v-slot:heading1>
        <div class="home-fragment65">
          <span class="home-text65">Contact Information</span>
        </div>
      </template>
      <template v-slot:address>
        <div class="home-fragment66">
          <span class="home-text66">123 Design Street, Cityville, USA</span>
        </div>
      </template>
    </contact-form7>
  </div>
</template>

<script>
import AppNavbar8 from '../components/navbar8'
import AppHero17 from '../components/hero17'
import AppFeatures24 from '../components/features24'
import AppCta26 from '../components/cta26'
import AppFeatures25 from '../components/features25'
import AppContact10 from '../components/contact10'
import AppFooter4 from '../components/footer4'
import AppBanner1 from '../components/banner1'
import ContactForm7 from '../components/contact-form7'

export default {
  name: 'Home',
  props: {},
  components: {
    AppNavbar8,
    AppHero17,
    AppFeatures24,
    AppCta26,
    AppFeatures25,
    AppContact10,
    AppFooter4,
    AppBanner1,
    ContactForm7,
  },
  metaInfo: {
    title: 'Empty Ringed Camel',
    meta: [
      {
        property: 'og:title',
        content: 'Empty Ringed Camel',
      },
    ],
  },
}
</script>

<style scoped>
.home-container {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
 
.home-fragment10 {
  display: contents;
}
 
.home-text10 {
  display: inline-block;
}
 
.home-fragment11 {
  display: contents;
}
 
.home-text11 {
  display: inline-block;
}
 
.home-fragment12 {
  display: contents;
}
 
.home-text12 {
  display: inline-block;
}
 
.home-fragment13 {
  display: contents;
}
 
.home-text13 {
  display: inline-block;
}
 
.home-fragment14 {
  display: contents;
}
 
.home-text14 {
  display: inline-block;
}
 
.home-fragment15 {
  display: contents;
}
 
.home-text15 {
  display: inline-block;
}
 
.home-fragment16 {
  display: contents;
}
 
.home-text16 {
  display: inline-block;
}
 
.home-fragment17 {
  display: contents;
}
 
.home-text17 {
  display: inline-block;
}
 
.home-fragment18 {
  display: contents;
}
 
.home-text18 {
  display: inline-block;
}
 
.home-fragment19 {
  display: contents;
}
 
.home-text19 {
  display: inline-block;
}
 
.home-fragment20 {
  display: contents;
}
 
.home-text20 {
  display: inline-block;
}
 
.home-fragment21 {
  display: contents;
}
 
.home-text21 {
  display: inline-block;
}
 
.home-fragment22 {
  display: contents;
}
 
.home-text22 {
  display: inline-block;
}
 
.home-fragment23 {
  display: contents;
}
 
.home-text23 {
  display: inline-block;
}
 
.home-fragment24 {
  display: contents;
}
 
.home-text24 {
  display: inline-block;
}
 
.home-fragment25 {
  display: contents;
}
 
.home-text25 {
  display: inline-block;
}
 
.home-fragment26 {
  display: contents;
}
 
.home-text26 {
  display: inline-block;
}
 
.home-fragment27 {
  display: contents;
}
 
.home-text27 {
  display: inline-block;
}
 
.home-fragment28 {
  display: contents;
}
 
.home-text28 {
  display: inline-block;
}
 
.home-fragment29 {
  display: contents;
}
 
.home-text29 {
  display: inline-block;
}
 
.home-fragment30 {
  display: contents;
}
 
.home-text30 {
  display: inline-block;
}
 
.home-fragment31 {
  display: contents;
}
 
.home-text31 {
  display: inline-block;
}
 
.home-fragment32 {
  display: contents;
}
 
.home-text32 {
  display: inline-block;
}
 
.home-fragment33 {
  display: contents;
}
 
.home-text33 {
  display: inline-block;
}
 
.home-fragment34 {
  display: contents;
}
 
.home-text34 {
  display: inline-block;
}
 
.home-fragment35 {
  display: contents;
}
 
.home-text35 {
  display: inline-block;
}
 
.home-fragment36 {
  display: contents;
}
 
.home-text36 {
  display: inline-block;
}
 
.home-fragment37 {
  display: contents;
}
 
.home-text37 {
  display: inline-block;
}
 
.home-fragment38 {
  display: contents;
}
 
.home-text38 {
  display: inline-block;
}
 
.home-fragment39 {
  display: contents;
}
 
.home-text39 {
  display: inline-block;
}
 
.home-fragment40 {
  display: contents;
}
 
.home-text40 {
  display: inline-block;
}
 
.home-fragment41 {
  display: contents;
}
 
.home-text41 {
  display: inline-block;
}
 
.home-fragment42 {
  display: contents;
}
 
.home-text42 {
  display: inline-block;
}
 
.home-fragment43 {
  display: contents;
}
 
.home-text43 {
  display: inline-block;
}
 
.home-fragment44 {
  display: contents;
}
 
.home-text44 {
  display: inline-block;
}
 
.home-fragment45 {
  display: contents;
}
 
.home-text45 {
  display: inline-block;
}
 
.home-fragment46 {
  display: contents;
}
 
.home-text46 {
  display: inline-block;
}
 
.home-fragment47 {
  display: contents;
}
 
.home-text47 {
  display: inline-block;
}
 
.home-fragment48 {
  display: contents;
}
 
.home-text48 {
  display: inline-block;
}
 
.home-fragment49 {
  display: contents;
}
 
.home-text49 {
  display: inline-block;
}
 
.home-fragment50 {
  display: contents;
}
 
.home-text50 {
  display: inline-block;
}
 
.home-fragment51 {
  display: contents;
}
 
.home-text51 {
  display: inline-block;
}
 
.home-fragment52 {
  display: contents;
}
 
.home-text52 {
  display: inline-block;
}
 
.home-fragment53 {
  display: contents;
}
 
.home-text53 {
  display: inline-block;
}
 
.home-fragment54 {
  display: contents;
}
 
.home-text54 {
  display: inline-block;
}
 
.home-fragment55 {
  display: contents;
}
 
.home-text55 {
  display: inline-block;
}
 
.home-fragment56 {
  display: contents;
}
 
.home-text56 {
  display: inline-block;
}
 
.home-fragment57 {
  display: contents;
}
 
.home-text57 {
  display: inline-block;
}
 
.home-fragment58 {
  display: contents;
}
 
.home-text58 {
  display: inline-block;
}
 
.home-fragment59 {
  display: contents;
}
 
.home-text59 {
  display: inline-block;
}
 
.home-fragment60 {
  display: contents;
}
 
.home-text60 {
  display: inline-block;
}
 
.home-fragment61 {
  display: contents;
}
 
.home-text61 {
  display: inline-block;
}
 
.home-fragment62 {
  display: contents;
}
 
.home-text62 {
  display: inline-block;
}
 
.home-fragment63 {
  display: contents;
}
 
.home-text63 {
  display: inline-block;
}
 
.home-fragment64 {
  display: contents;
}
 
.home-text64 {
  display: inline-block;
}
 
.home-fragment65 {
  display: contents;
}
 
.home-text65 {
  display: inline-block;
}
 
.home-fragment66 {
  display: contents;
}
 
.home-text66 {
  display: inline-block;
}
</style>
